/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import TOC from '@ember/component/template-only';
import type { TEntityType } from 'volta/models/types/entity-types';

type TagsEntityType = Extract<
  TEntityType,
  'skus' | 'bufferProfiles' | 'dafProfiles' | 'aduProfiles' | 'parts' | 'importHistos'
>;

export interface FiltersTagsFilterSignature
  extends IFilterArgs<{
    entityTypes: TagsEntityType[];
    warehouseIds?: string[];
    tag?: string;
  }> {}

const FiltersTagsFilterComponent = TOC<FiltersTagsFilterSignature>();

export default FiltersTagsFilterComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Filters::TagsFilter': typeof FiltersTagsFilterComponent;
    'filters/tags-filter': typeof FiltersTagsFilterComponent;
  }
}
